import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {ClassifiedsService} from '../../services/classifieds.service';
import {UrlService} from '../../services/url.service';

@Component({
    templateUrl: 'classifieds.component.html',
})
export class ClassifiedsComponent implements OnInit, OnDestroy {

    constructor(public classifiedsService: ClassifiedsService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.classifiedsService.getBuildings();

        this.urlService.onUrlChange.subscribe(() => {
            this.classifiedsService.tabId = this.urlService.queryParams['tab'];
            // this.classifiedsService.getData();
        });
        this.urlService.queryParams['status'] = 'received';
        this.urlService.setQueryParams('allClassifieds');
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.classifiedsService.resetData();
        this.urlService.resetQueryParams();
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.classifiedsService.emptyRowService.fillEmptyRow();
    }

}





// WEBPACK FOOTER //
// /app/src/app/views/classifieds/classifieds.component.ts